import Elements from "../lib/elements";

const CORE = {

	classNames: {
		minicart: 'brtn-header--main__ln__menu__item__btn--cart',
		pop: 'brtn-header--main__ln__menu__item__btn--pop'
	},

	elements: null,

	set: function (content) {
		const els = CORE.elements;
		var i = 0;
		var $el;

		if (els === null || typeof content !== 'string') {
			return false;
		}

		for (i; i < els.length; i++) {
			els[i].innerHTML = content;

			$el = $(els[i]);

			if (!$el.hasClass(CORE.classNames.pop)) {
				$el.addClass(CORE.classNames.pop);
			}
		}

	},

	construct: function () {

		CORE.elements = Elements({
			selector: CORE.classNames.minicart
		});

		return {
			elements: CORE.elements,
			set: CORE.set
		};
	}


};

export default CORE.construct;